export const itemIsSelected = (pathname: string, url: string, exact = false) => {
  if (exact === true) {
    return pathname === url;
  }

  return pathname.startsWith(url);
};
